/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function WorkFeedFilter(elem) {
        Behaviors.init(WorkFeedFilter, this, arguments);
        var $thisElem = this.$elem;

        function filterTags() {
            $thisElem.find('.WorkFeedFilter-content_filters_dropdown_result_item_tags').html('');
            $thisElem.parents('.WorkFeedFilter-content_filters_options').find('.WorkFeedFilter-content_filters_popup').show();
            $thisElem.find('.WorkFeedFilter-content_filters_item_dropdown-menu_list_item--location input:checked, .WorkFeedFilter-content_filters_item_dropdown-menu_list_item--practice_area input:checked').each(function (index) {
                $thisElem.find('.WorkFeedFilter-content_filters_dropdown_result_item_tags').append(
                    `<span class="filter-tag"><span class="remove-filter" data-filter="` + $(this).val() + `"><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.99999 4.05732L8.29999 0.757324L9.24266 1.69999L5.94266 4.99999L9.24266 8.29999L8.29999 9.24266L4.99999 5.94266L1.69999 9.24266L0.757324 8.29999L4.05732 4.99999L0.757324 1.69999L1.69999 0.757324L4.99999 4.05732Z" fill="#121212"/></svg></span>` + $(this).parent().find('.WorkFeedFilter-content_filters_item_name').text() +
                `</span>`);
            });
        }

        

        // Shop Filters Ajax
        function workFilters(paged, filterActive = '') {
            var scrollOffset = $thisElem.offset().top - $('header').outerHeight() - 96,
                loop = $thisElem.find('.WorkFeedFilter-content_grid_wrap'),
                location = '',
                practiceArea = '',
                specialFeatures = '',
                urlParameters = '';
            
            $thisElem.find('.WorkFeedFilter-content_filters_item_dropdown-menu_list_item--location input:checked').each(function (index) {
                location += index > 0 ? ',' : '';
                location += $(this).val();
            });

            $thisElem.find('.WorkFeedFilter-content_filters_item_dropdown-menu_list_item--practice_area input:checked').each(function (index) {
                practiceArea += index > 0 ? ',' : '';
                practiceArea += $(this).val();
            });

            if(practiceArea == 'commercial-office') {
                $thisElem.addClass('WorkFeedFilter--commercial-office_active');
            } else {
                $thisElem.removeClass('WorkFeedFilter--commercial-office_active');
            }

            if($thisElem.find('.WorkFeedFilter-content_filters_item_result_list_tags--practice_area input:checked').length > 0) {
                practiceArea = '';
                $thisElem.find('.WorkFeedFilter-content_filters_item_result_list_tags--practice_area input:checked').each(function (index) {
                    practiceArea += index > 0 ? ',' : '';
                    practiceArea += $(this).val();
                });
            }
            
            //Code snippet commented because change of items functionality
            // if($thisElem.find('.WorkFeedFilter_item--special_features input:checked').is(':checked')) {
            //     specialFeatures = $thisElem.find('.WorkFeedFilter_item--special_features input:checked').val();
            //     filterActive = 'specialFeatures';
            // }

            //Reset location and practiceArea if specialFeatures are selected
            if(filterActive == '') {
                $thisElem.addClass('WorkFeedFilter--dropdowns_active');
                $thisElem.removeClass('WorkFeedFilter--special_features_active');
            } else {
                $thisElem.addClass('WorkFeedFilter--special_features_active');
                $thisElem.removeClass('WorkFeedFilter--dropdowns_active');
            }

            if (location.length < 1 && practiceArea.length < 1 && specialFeatures.length < 1 ) {
                $thisElem.removeClass('WorkFeedFilter--special_features_active');
                $thisElem.removeClass('WorkFeedFilter--dropdowns_active');
            }
            if (filterActive !== 'specialFeatures') {
                //Define loacation item in the URL
                if (location.length > 0) {
                    urlParameters += 'location=' + location;
                }
                //Define practiceArea item in the URL
                if (practiceArea.length > 0) {
                    urlParameters += urlParameters ? '&' : '';
                    urlParameters += 'practicearea=' + practiceArea;
                }
            } else {
                //Define specialFeatures item in the URL
                if (specialFeatures.length > 0) {
                    urlParameters += 'specialfeatures=' + specialFeatures;
                }
            }

            //Define URL behaviour
            urlParameters = urlParameters ? '?' + urlParameters : '';
            if (urlParameters.length > 0) {
                history.replaceState(undefined, undefined, urlParameters);
            } else {
                history.replaceState(undefined, undefined, '?');
            }
            // console.log(filterActive);
            $.ajax({
                url: theme_ajax_url, // AJAX handler
                data: {
                    'action': 'work_filters',
                    paged: paged,
                    location: location,
                    practiceArea: practiceArea,
                    specialFeatures: specialFeatures,
                    filterActiveResult: filterActive
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    $thisElem.addClass('SCWorkFeedFilter-items--loading');
                },
                success: function (response) {
                    loop.html(response);

                    $thisElem.removeClass('SCWorkFeedFilter-items--loading');

                    filterTags();

                    // Scroll to top of the products
                    // $('html, body').animate({
                    //     'scrollTop': scrollOffset
                    // }, 500);
                }
            });
            return false;
        }

        // Remove Filter by filter item
        $(document).on('click', '.remove-filter', function (e) {
            e.preventDefault();
            var $this = $(this);
            $thisElem.find('.WorkFeedFilter-content_filters_select_dropdowns [value="' + $this.data('filter') + '"]').prop('checked', false);
            $this.parent().remove();
            workFilters(1);
        });

        // Remove Filters - reset filters button
        $(document).on('click', '#clearWorkFiltersBtn', function (e) {
            e.preventDefault();
            $thisElem.find('.WorkFeedFilter-content_filters_item_form_location input[type="checkbox"]').each(function(){
                $(this).prop('checked', false);
            });
            $thisElem.find('.WorkFeedFilter-content_filters_item_form_practice_area input[type="checkbox"]').each(function(){
                $(this).prop('checked', false);
            });
            $thisElem.find('.WorkFeedFilter-content_filters_item_result_list_tags_form_practice_area input[type="checkbox"]').each(function(){
                $(this).prop('checked', false);
            });
            //Code snippet commented because change of items functionality
            // $thisElem.find('.WorkFeedFilter-content_filters_item_form_special_features input[type="radio"]').each(function(){
            //     $(this).prop('checked', false);
            // });
            $thisElem.find('.WorkFeedFilter-content_filters_dropdown_result_item_tags').html('');
            workFilters(1);
        });
        $(document).on('click', '#clearWorkFiltersBtnPage', function (e) {
            e.preventDefault();
            $thisElem.find('.WorkFeedFilter-content_filters_item_form_location input[type="checkbox"]').each(function(){
                $(this).prop('checked', false);
            });
            $thisElem.find('.WorkFeedFilter-content_filters_item_form_practice_area input[type="checkbox"]').each(function(){
                $(this).prop('checked', false);
            });
            $thisElem.find('.WorkFeedFilter-content_filters_item_result_list_tags_form_practice_area input[type="checkbox"]').each(function(){
                $(this).prop('checked', false);
            });
            //Code snippet commented because change of items functionality
            // $thisElem.find('.WorkFeedFilter-content_filters_item_form_special_features input[type="radio"]').each(function(){
            //     $(this).prop('checked', false);
            // });
            $thisElem.find('.WorkFeedFilter-content_filters_dropdown_result_item_tags').html('');
            workFilters(1);
        });

        // Pagination
        $(document).on("click", '.SCNumberPagination a', function (e) {
            e.preventDefault();
            var $this = $(this),
                paged = $(this).text(),
                current = parseInt($thisElem.find('.SCNumberPagination .current').text());

            if ($this.hasClass('prev')) {
                paged = parseInt(current - 1);
            } else if ($this.hasClass('next')) {
                paged = parseInt(current + 1);
            }

            workFilters(paged);
        });

        // Filter 
        $thisElem.find('.WorkFeedFilter-content_filters_item_dropdown-menu_list_item--location input[type="checkbox"]').on('change', function () {
            workFilters(1);
        });
        $thisElem.find('.WorkFeedFilter-content_filters_item_dropdown-menu_list_item--practice_area input[type="checkbox"]').on('change', function () {
            workFilters(1);
        });
        $thisElem.find('.WorkFeedFilter-content_filters_item_result_list_tags--practice_area input[type="checkbox"]').on('change', function () {

            //reference clicked checkbox
            var activatedCheckbox_value = $(this).val();

            //client requested to ONLY select one filter here so we need to deactivate other sub-filters
            $('.WorkFeedFilter-content_filters_item_result_list_tags--practice_area input[type="checkbox"]').each( function(){
                if( $(this).val() !== activatedCheckbox_value ){
                    //remove check
                    $(this).prop("checked", false);
                }
            });

            workFilters(1);
        });
        
        //Code snippet commented because change of items functionality
        // $thisElem.find('.WorkFeedFilter_item--special_features input[type="radio"]').on('change', function () {
        //     workFilters(1, 'specialFeatures');
        //     $thisElem.find('.WorkFeedFilter-content_filters_item_form_location')[0].reset();
        //     $thisElem.find('.WorkFeedFilter-content_filters_item_form_practice_area')[0].reset();
        //     $thisElem.find('.WorkFeedFilter-content_filters_item_result_list_tags_form_practice_area')[0].reset();
        // });

        
        //Popup functions
        //Open popup on click
        $(".WorkFeedFilter-content_filters_popup_item_click").click(function (e) {
            var $this = $(this);
            e.stopPropagation();
            $this.parents('.WorkFeedFilter').find('.WorkFeedFilter-content').addClass('WorkFeedFilter-content_grid--popup-activate');
        });
        //Leave popup on click on popup it self
        $(".WorkFeedFilter-content_grid_popup_elements").click(function (e) {
            e.stopPropagation();
        });
        //Remove popup on back link click
        $(".WorkFeedFilter-content_grid_popup_elements_back").click(function (e) {
            var $this = $(this);
            $this.parents('.WorkFeedFilter').find('.WorkFeedFilter-content').removeClass('WorkFeedFilter-content_grid--popup-activate');
        });
        //Remove popup on popup item click
        $(".WorkFeedFilter_item--special_features").click(function () {
            var $this = $(this);
            $this.parents('.WorkFeedFilter').find('.WorkFeedFilter-content').removeClass('WorkFeedFilter-content_grid--popup-activate');
        });
        //Remove popup on document/ body click
        $(document).on('click', function() {
            $('.WorkFeedFilter-content').removeClass('WorkFeedFilter-content_grid--popup-activate');
        });

        //Dropdown functionality
        var selectItem = $('.WorkFeedFilter-content_filters_item_dropdown-button');
        selectItem.on('click', function(){
            var $this = $(this);
            if (!($this.parents('.WorkFeedFilter-content_filters_item').find('.WorkFeedFilter-content_filters_item_list').hasClass('WorkFeedFilter-content_filters_item_list--dropdown_active'))) {
                $this.parents('.WorkFeedFilter-content_filters_select_dropdowns').find('.WorkFeedFilter-content_filters_item_list').removeClass('WorkFeedFilter-content_filters_item_list--dropdown_active');
                $this.parents('.WorkFeedFilter-content_filters_item').find('.WorkFeedFilter-content_filters_item_list').addClass('WorkFeedFilter-content_filters_item_list--dropdown_active');
            } else {
                $this.parents('.WorkFeedFilter-content_filters_item').find('.WorkFeedFilter-content_filters_item_list').removeClass('WorkFeedFilter-content_filters_item_list--dropdown_active');
            }
        });
        
        // deactivate dropdown menu popup on mouseleave instead of document click
        $('.WorkFeedFilter-content_filters_item_dropdown-menu').on('mouseleave', function(){

            if( ! $('.WorkFeedFilter-content').hasClass('SCWorkFeedFilter-items--loading') ){

                $(this).parent().removeClass('WorkFeedFilter-content_filters_item_list--dropdown_active');

            }
        });
        
        $(".WorkFeedFilter-content_filters_item_list").click(function (e) {
            e.stopPropagation();
        });

        $(document).on('click', function() {
            $('.WorkFeedFilter-content_filters_item_list').removeClass('WorkFeedFilter-content_filters_item_list--dropdown_active');
        });

        filterTags();

    }
    Behaviors.inherit(WorkFeedFilter, Behaviors.Behavior);
    WorkFeedFilter.QUERY = "[data-WorkFeedFilter]";
    WorkFeedFilter.ELEMENTS = {
        dummyVar: ".WorkFeedFilter-class",
    };
    Behaviors.register_behavior(WorkFeedFilter);
    module.WorkFeedFilter = WorkFeedFilter;
    return module;
}(window.jQuery, window.Behaviors));
